import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import getConfigurationByKey from 'store/app/selector/getConfigurationByKey';
import { PixleeWidget } from 'store/landing/types';
import PixleeManager from './PixleeManager';

export interface PixleeWidgetProps {
  pixleeWidget: PixleeWidget;
}

const PixleeWidgetBlock: FC<PixleeWidgetProps> = ({ pixleeWidget }) => {
  const pixleeApiKey = useSelector(getConfigurationByKey('pixlee_api_key'));
  const pixleeAccountId = useSelector(getConfigurationByKey('pixlee_account_id'));

  const pixleeManager = new PixleeManager(pixleeAccountId);

  if (!pixleeWidget.enabled) {
    return null;
  }

  useEffect(() => {
    pixleeManager.init(pixleeApiKey, 'async');
  }, []);

  return (
    <div
      id="pixlee_container"
      data-pixlee-widget-id={pixleeWidget.widgetId}
      data-pixlee-widget-type="simple"
      data-pixlee-widget-sku={pixleeWidget.skuId}
      data-pixlee-widget-categor-id={pixleeWidget.categoryId}
      data-pixlee-widget-category-name={pixleeWidget.categoryName}
      data-pixlee-widget-fallback-id={pixleeWidget.fallbackWidget ? pixleeWidget.fallbackWidget.widgetId : ''}
      data-pixlee-widget-fallback-type={pixleeWidget.fallbackWidget ? 'simple' : ''}
      data-pixlee-widget-fallback-sku={pixleeWidget.fallbackWidget ? pixleeWidget.fallbackWidget.skuId : ''}
      data-pixlee-widget-fallback-category-id={
        pixleeWidget.fallbackWidget ? pixleeWidget.fallbackWidget.categoryId : ''
      }
      data-pixlee-widget-fallback-category-name={
        pixleeWidget.fallbackWidget ? pixleeWidget.fallbackWidget.categoryName : ''
      }
      className="pixlee-widget"
    />
  );
};

export default PixleeWidgetBlock;
